import type { CSSProperties } from 'react';

import styled from 'styled-components';

import { NAV_HEIGHT } from 'src/consts';

import { NavTheme, ResponsiveView } from './constants';

export const HeaderWrapper = styled.div`
  position: relative;
  z-index: ${props => props.theme.zIndices.overlay};
`;

export const NavWrapper = styled.div<{
  hasFlexWrap: boolean;
  isOnboardingFlow: boolean;
  navTheme: NavTheme;
  responsiveView: ResponsiveView;
  style?: CSSProperties;
}>`
  display: flex;
  align-items: center;
  flex-wrap: ${props => (props.hasFlexWrap ? 'wrap' : 'nowrap')};
  flex-wrap: 'nowrap';

  background-color: ${props =>
    props.navTheme === NavTheme.blue ? props.theme.colors.capsuleBlue50 : props.theme.colors.white};
  color: ${props => (props.navTheme === NavTheme.blue ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  box-shadow: ${props =>
    props.navTheme === NavTheme.blue || props.isOnboardingFlow ? `none` : props.theme.shadows.dp6};
  z-index: ${props => props.theme.zIndices.overlay};
  padding: ${props => props.theme.space.none} ${props => props.theme.space.s7};
  height: ${NAV_HEIGHT}px;

  .capsuleLogoAlternateColor {
    fill: ${props =>
      props.navTheme === NavTheme.blue ? props.theme.colors.white : props.theme.colors.capsuleBlue50} !important;
  }
  a {
    color: currentColor !important;
  }
  ${props => props.theme.mediaQueries.XXLargeDown} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s5};
    ${props => (props.responsiveView === ResponsiveView.desktop ? `display: none;` : ``)}
  }

  ${props => props.theme.mediaQueries.XXLarge} {
    ${props => (props.responsiveView === ResponsiveView.mobile ? `display: none;` : ``)}
  }
`;

// Desktop Nav Components

export const DesktopHeaderContainer = styled.div<{ isOnboardingFlow: boolean }>`
  display: flex;
  width: 100%;
  margin-top: ${props => (props.isOnboardingFlow ? props.theme.space.s3 : '')};
`;

export const DesktopLeftNav = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex: 1 1 auto;

  > a:not(:first-of-type) {
    margin-left: ${props => props.theme.space.s7};
  }
  > a:first-of-type {
    margin-left: ${props => props.theme.space.s9};
  }

  @media screen and (max-width: 1350px) {
    > a:not(:first-of-type) {
      margin-left: ${props => props.theme.space.s6};
    }
    > a:first-of-type {
      margin-left: ${props => props.theme.space.s7};
    }
  }
`;

export const DesktopRightNav = styled.div`
  display: flex;
  align-items: center;
  flex-direction: flex-end;
  flex-wrap: nowrap;
  a:not(:last-child) {
    margin-right: ${props => props.theme.space.s7};
  }

  @media screen and (max-width: 1350px) {
    > a:not(:last-child) {
      margin-right: ${props => props.theme.space.s6};
    }
  }
`;

// Mobile Nav Components

export const MobileHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  height: calc(${NAV_HEIGHT}px - 8px);
  width: 100%;
`;

export const LeftNav = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 50%;
`;

export const MobileIconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const RightNav = styled.div<{ noFlex?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex: 1 1 50%;
  ${props => props.noFlex && 'flex: none;'}
`;

// Nav Components

export const BottomNav = styled.div<{ showMenu: boolean }>`
  display: ${props => (props.showMenu ? 'none' : 'flex')};
  flex-basis: 100%;

  transform: translateX(-4.8rem);

  ${props => props.theme.mediaQueries.extraLargeDown} {
    transform: translateX(-2.4rem);
  }

  margin-bottom: 0;
  margin-top: auto;
`;

export const ButtonWithLinkAppearance = styled('button').attrs({ type: 'button' })`
  appearance: none;
  color: currentColor;
  padding: 0;
  border: none;
  background-color: inherit;
  font-size: ${props => props.theme.fontSizes.body};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.book};
`;
